/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductNodeDto } from './product-node-dto';


/**
 * Representation of a multiple product details edited in the UI
 */
export interface MultiProductNodeDto { 
    identifers?: Array<string>;
    overwriteCategories?: boolean;
    overwriteSUI?: boolean;
    productDetails?: ProductNodeDto;
    organizationId?: string;
    requestedType?: MultiProductNodeDtoRequestedTypeEnum;
}
export enum MultiProductNodeDtoRequestedTypeEnum {
    Standard = 'STANDARD',
    PartsOnly = 'PARTS_ONLY',
    Referencing = 'REFERENCING'
};



